import React, {FC} from 'react';
import {ITrack} from "../../modules/rest";
import Marquee from "../Marquee";

interface Props {
  className?: string;
  track: ITrack;
  inline?: boolean;
  active?: boolean;
  width?: number;
}

const TrackTitle: FC<Props> = ({active, track, className, inline, width}) => {
  return (
    <Marquee active={active || false} width={width}>
      <div className={`track-title${inline ? ' track-title-inline' : ''} text-truncate ${className || ''}`} style={{minWidth: width || 'auto'}}>
        <div className='d-grid overflow-hidden '>
          <span className="bold-20 text-nowrap text-truncate" title={track.title}>
            {track.title}
          </span>
        </div>
        {inline ? <span className='px-1 text-muted-14'>&#8226;</span> : null}
        <div className='d-grid overflow-hidden'>
          <span className="bold text-muted text-truncate" title={track.performer.stageName || ''}  style={{marginTop: 2}}>
           {track.performer.stageName}
          </span>
        </div>
      </div>
    </Marquee>
  );
}

export default TrackTitle;